import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { Container, QuoteButton, WhatsAppButton } from "@/components/site/Primitives";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | KhozaLand" description="The page you were looking for could not be found." path="/404" noindex />
      <section className="bg-white py-24 lg:py-32" data-testid="not-found-page">
        <Container className="max-w-3xl text-center">
          <img src="/images/khozaland-logo-sm.png" alt="" aria-hidden="true" className="mx-auto w-28 opacity-30" />
          <p className="kl-eyebrow mt-8 text-black/50">Error 404</p>
          <h1 className="kl-h1 mt-4">This page could not be found.</h1>
          <p className="mx-auto mt-5 max-w-lg text-base leading-7 text-black/65">The link may be broken or the page may have moved. Try one of these instead:</p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <Link to="/" className="kl-btn kl-btn-outline h-12 px-6" data-testid="not-found-home-link">Back to Home</Link>
            <QuoteButton label="Request a Quote" className="h-12" testId="not-found-quote-button" />
            <WhatsAppButton className="h-12" testId="not-found-whatsapp-button" />
          </div>
          <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
            {[["/custom-tshirt-printing", "Custom T-Shirts"], ["/xhosa-cultural-products", "Xhosa Cultural Products"], ["/personalised-gifts", "Personalised Gifts"], ["/gallery", "Our Work"]].map(([to, l]) => (
              <li key={to}><Link to={to} className="underline underline-offset-4">{l}</Link></li>
            ))}
          </ul>
        </Container>
      </section>
    </>
  );
}
